/**
 * Maps stock units to selectable size labels.
 */
export const SIZE_EXPANSION = {
    '1': ['L', 'XL'],
    '2': ['2XL', '3XL']
};

/**
 * Normalizes specific labels back to stock units (matches backend).
 */
export const normalizeSize = (size) => {
    if (!size) return size;
    const s = size.toString().toUpperCase().trim();
    if (['L', 'XL'].includes(s)) return '1';
    if (['2XL', '3XL', 'XXL', 'XXXL'].includes(s)) return '2';
    return size;
};

/**
 * Returns a friendly label for stock units or passes through specific sizes.
 */
export const formatSize = (size) => {
    if (size === '1') return 'L - XL';
    if (size === '2') return '2XL - 3XL';
    return size;
};

/**
 * Formats stock units for display in management views.
 */
export const formatSizeMapping = (size) => {
    if (size === '1') return '1 (L, XL)';
    if (size === '2') return '2 (2XL, 3XL)';
    return size;
};

/**
 * Robustly formats an order's variant for display, handling both 
 * legacy string variants and new object-based shipping variants.
 */
export const formatOrderVariant = (order) => {
    if (!order) return "N/A";
    
    // 1. Try structured shipping variant
    const sv = order.shipping?.variant;
    if (sv && (sv.color || sv.size)) {
        return `${sv.color || 'N/A'} - ${formatSize(sv.size) || 'N/A'}`;
    }

    // 2. Fallback to legacy string variant
    return order.variant || "N/A";
};
